export const createArrayOfSize = <T>(
    size: number,
    callback = (idx: number): T => idx as unknown as T,
): T[] =>
    Array(size)
        .fill(null)
        .map((_, idx) => callback(idx));
